import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';

@Pipe({
    name: 'orderBy',
    standalone: true
})
export class OrderByPipe implements PipeTransform {
    transform(array: any[], orderBy: string, reverse = false) {
        if (!array || !orderBy) {
            return array;
        }

        const result = Array.from(array).sort((item1: any, item2: any) => {
            return this.orderByComparator(item1[orderBy], item2[orderBy]);
        });

        if (reverse) {
            return result.reverse();
        }

        return result;
    }

    orderByComparator(a: any, b: any): number {
        if (typeof a === 'string' && typeof b === 'string') {
            return this.defaultCompare(a.toLowerCase(), b.toLowerCase());
        }
        return this.defaultCompare(a, b);
    }

    defaultCompare(a: any, b: any): number {
        const isFirstNull = isEmpty(a);
        const isSecondNull = isEmpty(b);

        if (a === b) {
            return 0;
        }
        if (isFirstNull) {
            return 1;
        }
        if (isSecondNull) {
            return -1;
        }
        return a > b ? 1 : -1;
    }
}
